import Vue from "vue";

export default {
    recuperarTiposAlocacao() {
        return Vue.axios.get("tipoAlocacao");
    },
};
